export default __webpack_public_path__ + "b30114955c6ebf03fd9a4be751cdb909.svg";